import { ReactNode } from 'react'

import styles from './information-banner.module.scss'

export type InformationBannerProps = {
  children: ReactNode
}

export const InformationBanner = ({ children }: InformationBannerProps) => {
  return (
    <div className={styles.container}>
      {children}
    </div>
  )
}
